import saveAs from 'file-saver'
import { get, getBlobJson, putBlobJson } from '@/api'
import { momentDate, stripHtmlTags, modelNamePluralize } from '@/utils'

export async function resolveModelMetaFromId(id) {
  let modelMetaComponents = null
  if (id) {
    const resolverData = await get(`resolver/${id}/`, {
      cancellable: false,
    }).then((r) => r.data)
    modelMetaComponents = {
      appName: resolverData?.app_name,
      modelName: resolverData?.model_name,
      modelType: resolverData?.model_type,
    }
  }
  return modelMetaComponents
}

export async function loadItemData(id, { appName, modelName }) {
  if (!appName || !modelName) {
    // modelNamePluralize
    ;({ appName, modelName } = await resolveModelMetaFromId(id))
  }
  const pluralModelName = modelNamePluralize(modelName)
  const response = await get(`${appName}/${pluralModelName}/${id}/`)
  return response.data.results
}

export function enrichResolverItem(item, storeModelApps, modelNameLabels) {
  const label = modelNameLabels[item.model_name]
  const modelName = label ? label : item.model_name
  let itemInfo = [modelName]
  /* WEIRD ON / FIXME / TODO */
  const modelType =
    item.model_name === 'experiment' && item.model_type === 'DEFAULT'
      ? 'ENTRY'
      : item.model_type
  /* WEIRD OFF */
  const modelTypeLabel =
    storeModelApps[item.app_name][item.model_name][modelType].label
  itemInfo.push(modelTypeLabel)
  const strippedDesc = stripHtmlTags(item.description)
  const maxLen = 1000
  const itemDesc = [strippedDesc.slice(0, maxLen), strippedDesc.length > maxLen]
  return {
    app_name: item.app_name || '',
    created_by: item.created_by || 'Unknown',
    description: itemDesc || [],
    model_name: item.model_name || '',
    modified_by: item.modified_by || 'Unknown',
    modified: item.modified
      ? momentDate(item.modified).format('MMMM Do, YYYY')
      : '',
    modified_ago: item.modified ? momentDate(item.modified).fromNow() : '',
    name: item.name || '',
    owner: item.owner || {},
    id: item.order !== null ? item.order.id : item.id,
    itemInfo: itemInfo.join(' / '),
  }
}

export async function downloadFile({
  url,
  method = 'get',
  payload = {},
  fileName = null,
}) {
  const hasPayload = Object.keys(payload).length
  if (hasPayload) payload = { data: payload }
  const downloadMethod =
    method === 'put' || hasPayload ? putBlobJson : getBlobJson

  const response = await downloadMethod(url, { ...payload })

  if (!fileName) {
    const contentDisposition = response.headers['content-disposition']
    fileName =
      contentDisposition
        ?.split('filename=')[1]
        ?.split(';')[0]
        ?.replace(/^"(.*)"$/, '$1') || `download_${Date.now()}`
  }

  saveAs(response.data, fileName)
  return response
}
